var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SiteButton',_vm._b({on:{"click":function($event){return _vm.$emit('click')}}},'SiteButton',_vm.$props,false),[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('Spinner',{staticClass:"button-spinner",attrs:{"waiting":_vm.waiting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }